import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

// declare constant at the top of the file
const FIXED_HEIGHT_IMAGE = 347;

export const HeroContainer = superstyled({
  name: 'ZuiHeroContainer',
  slot: 'Root',
  tag: Stack,
  propsNeeded: ['buyBoxHeight'],
  styles: ({ theme, buyBoxHeight }) => {
    const marginBottom = buyBoxHeight - FIXED_HEIGHT_IMAGE;

    return {
      [theme.breakpoints.up('lg')]: {
        marginBottom: marginBottom > 0 ? `${marginBottom}px` : 0,
        gap: theme.spacing(1),
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.grey.light,
        borderRadius: theme.shape.rounded['2xl'],
        boxShadow: theme.shadows[3],
      },
    };
  },
});

export const HeroContent = superstyled({
  name: 'ZuiHeroContent',
  slot: 'Root',
  tag: Grid,
  propsAdded: {
    flexWrap: 'wrap',
  },
  styles: ({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(3),

    [theme.breakpoints.up('lg')]: {
      gridAutoFlow: 'column',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateRows: 'repeat(2, auto)',
      gap: theme.spacing(4, 9),
    },
  }),
});
